import { MinusCircle, Plus, Warning } from '@phosphor-icons/react/dist/ssr';
import * as React from 'react';

import { Badge } from '../badge';

import type { DiscrepancyTypeValue } from '@devizy/shared';
import type { Icon } from '@phosphor-icons/react';

const DISCREPANCY_VARIANT: Record<
  Exclude<DiscrepancyTypeValue, 'NONE'>,
  { variant: 'secondary' | 'destructive'; className?: string; icon: Icon }
> = {
  ADDITION: { variant: 'secondary', className: 'bg-success/15 text-success', icon: Plus },
  MODIFICATION: { variant: 'secondary', className: 'bg-warning/15 text-warning', icon: Warning },
  DELETION_PROPOSED: { variant: 'destructive', icon: MinusCircle },
};

export interface DiscrepancyBadgeProps {
  type: DiscrepancyTypeValue;
  label: string;
}

export function DiscrepancyBadge({
  type,
  label,
}: DiscrepancyBadgeProps): React.ReactElement | null {
  if (type === 'NONE') {
    return null;
  }
  const variant = DISCREPANCY_VARIANT[type];
  const IconComponent = variant.icon;
  return (
    <Badge variant={variant.variant} className={variant.className}>
      <IconComponent weight="bold" aria-hidden className="mr-1 h-3 w-3" />
      {label}
    </Badge>
  );
}
